<template>
    <section class="gradient-custom">
        <div class="container my-5 py-5">
            <img v-bind:src="require('@/assets/logo_dark.png')" alt="Responsive image" style="width: 200px;">
            <div class="row d-flex justify-content-center py-5">
                <div class="col-md-7 col-lg-5 col-xl-8">
                    <div class="card" style="border-radius: 15px;">
                        <div class="card-body">
                            <h5 class="card-title">Tienes una suscripción activa</h5>
                            <p id="typeName" class="form-control form-control-lg" siez="17" aria-label="Default" aria-describedby="inputGroup-sizing-default">{{ user }}</p>
                            <br>
                            <h5 class="card-title">Tu suscripción vence el</h5>
                            <p id="typeName" class="form-control form-control-lg" siez="17" aria-label="Default" aria-describedby="inputGroup-sizing-default">{{ date }}</p>
                            <br>
                            <p align="left">*Solo aplica para usuarios Android y iOS ver <a href="https://napoleon.chat/terminos-condiciones" style="color:#d7a952;" target="_blank">términos y condiciones</a></p>
                            <a href="https://napoleon.chat/" type="button" class="btn btn-outline-dark">Salir</a>&nbsp;&nbsp;
                            <button type="button" class="btn btn-outline-warning" v-on:click="confirmPay">Comprar</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>

import HttpsUtils from '@/Utlis/HttpsUtils';

export default {
    name: 'SubscribedComponent',
    data(){
        return {
            user: "",
            date: ""
        }
    },
    mounted() {
        this.consultUser()
        this.consultInfoUser()
    },
    methods: {
        async consultUser () {
            let data = await new HttpsUtils().get('v2/public/user/' + this.$route.params.id)
            this.user = data.data.nick
        },
        async consultInfoUser() {
            let data = await new HttpsUtils().get('v3/payment/external/' + this.$route.params.id)
            this.date = data.data.expire
        },
        confirmPay(){
            this.$swal({
                title: 'Compra de suscripción',
                icon: 'info',
                text: 'Seguro que desea comprar otra suscripción, si compra otra suscripción la suscripción actual se borrara',
                confirmButtonText: 'Comprar',
                cancelButtonText: 'Cancelar',
                showCancelButton: true,
                showCloseButton: true,
                confirmButtonColor: '#d7a952',
                cancelButtonColor: '#212529'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$router.push({ name: 'unsubscribed', params: { id: this.$route.params.id } })
                } else {
                    this.$swal({
                        title: 'Compra de suscripción',
                        icon: 'info',
                        text: 'Compra cancelada',
                        confirmButtonColor: '#d7a952'
                    })
                }
            });
        },
    }
}
</script>